import { useEffect, useRef } from 'react';
import { GameEngine } from '@adgf/game-engine';
import type { GameEngineConfig, GameEngineEvents } from '@adgf/game-engine';
import Phaser from 'phaser';

interface GameCanvasProps {
  gameId: string;
  config?: Partial<GameEngineConfig>;
  events?: GameEngineEvents;
  scenes?: Phaser.Scene[];
}

export default function GameCanvas({ gameId, config, events, scenes }: GameCanvasProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const engineRef = useRef<GameEngine | null>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const engine = new GameEngine(
      { ...config, parent: containerRef.current },
      events,
    );
    engineRef.current = engine;
    engine.init(scenes ?? []);

    return () => {
      engine.destroy();
      engineRef.current = null;
    };
  }, [gameId, config, events, scenes]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        maxWidth: 800,
        aspectRatio: '4 / 3',
        margin: '0 auto',
        borderRadius: 'var(--radius)',
        overflow: 'hidden',
        boxShadow: 'var(--shadow)',
        background: 'var(--color-bg-secondary)',
      }}
      data-testid="game-canvas"
    />
  );
}
